import { createTheme, adaptV4Theme } from '@mui/material/styles';
import { getValue } from 'utilities/Utils';
import { ObjectKeyPaths } from 'utilities/Utils.types';
declare module '@mui/material/styles/createPalette' {
  interface CommonColors {
    black: string;
    white: string;
    transparent: string;
    lightSuccess: string;
    lightError: string;
  }
  interface Palette {
    backgrounds?: {
      primary: string;
      error: string;
      lightError: string;
      success: string;
      lightSuccess: string;
      warning: string;
      dark: string;
      light: string;
      dividerDark: string;
      divider: string;
      white: string;
    };
    gray?: {
      main: string;
      light: string;
    };
  }
  interface PaletteColor {
    lighter: string;
  }
  interface PaletteOptions {
    backgrounds?: {
      primary: string;
      error: string;
      lightError: string;
      success: string;
      lightSuccess: string;
      warning: string;
      dark: string;
      light: string;
      dividerDark: string;
    };
    gray?: {
      main: string;
      light: string;
    };
  }
}

// If you want to use theme colors in scss import variables.scss file in your scss file and use the variables
// variables.scss palette and theme palette both are linked to the same file.
// So if you are adding any changes to variables.scss file, you need to update the theme palette as well.
// So if you are adding any changes to theme palette, you need to update the variables.scss file as well.

const palette = {
  common: {
    dark: '#000000',
    black: '#0F0F0F',
    white: '#FFFFFF',
    transparent: 'transparent',
    lightSuccess: '#A9B466',
    lightError: '#EB6920',
    light: '#404040',
  },
  backgrounds: {
    primary: '#EFF1FF',
    success: '#E8FFF0',
    lightSuccess: '#F5FDEE',
    warning: '#FFF8EE',
    lightError: '#FEF8ED',
    error: '#FFE9E9',
    dark: '#EFEFEF',
    light: '#F8F8F8',
    white: '#FFFFFF',
    dividerDark: '#EBEBEB',
    divider: '#D2D1D1',
    overlay: '#40404080',
    info: '#E2F5FE',
  },
  divider: '#DEDEDE', // alternative divider -> #EBEBEB
  primary: {
    main: '#3543BF',
    light: '#C2C7EC',
    dark: '#1F2A8D',
    lighter: '#EFF1FF',
  },
  error: {
    main: '#C62828',
    light: '#FFEBEE',
    lighter: '#FFE9E9',
    dark: '#C62828',
  },
  success: {
    main: '#37BC8E',
    light: '#7CE3C0',
    lighter: '#E8F5E9',
    medium: '#81C784',
    dark: '#2E7D32',
    infoDefault: '#D78411',
  },
  warning: {
    main: '#F2A526',
    light: '#FADCAC',
    lighter: '#FFF8EE',
  },
  gray: {
    main: '#4A4A4A',
    light: '#8B8B8B',
  },
  text: {
    primary: '#404040', // dark
    secondary: '#787878', // light
    link: '#0B61D9',
    dark: '#343434',
    disable: '#0006',
    lightSecondary: '#858585',
  },
  info: {
    main: '#3543BF',
  },
  graph: {
    accent1: '#0F8EDB',
    accent2: '#EB9071',
    accent3: '#F1CB6A',
    accent4: '#D565BB',
  },
  secondary: {
    main: '#008CFF',
  },
};

export type PaletteColors = ObjectKeyPaths<typeof palette>;

export const getColor = (colorPath: PaletteColors) => {
  return getValue(palette, colorPath, 'inherit');
};

const theme = createTheme(
  adaptV4Theme({
    typography: {
      fontFamily: 'Roboto',
    },
    palette,
    breakpoints: {
      keys: ['xs', 'sm', 'md', 'lg', 'xl'],
      values: {
        xs: 576,
        sm: 768,
        md: 992,
        lg: 1280,
        xl: 1440,
      },
    },
    overrides: {
      MuiInput: {
        root: {
          padding: '10px 12px 9px',
          fontSize: '14px',
          lineHeight: '21px',
          color: '#0F0F0F',
          border: '1px solid #DEDEDE',
        },
      },
      MuiCheckbox: {
        root: {
          // background: '#FFFFFF',
          borderRadius: '4px',
        },
      },
      MuiChip: {
        root: {
          border: '1px solid #DEDEDE',
          borderRadius: '8px',
          height: '44px',
        },
      },
    },
  }),
);

export { theme };
